<div class="container">
  @for (item of operaciones(); track $index) {
  <div class="square" [routerLink]="[item.controlador + '/' + item.accion]">
    <div class="img-conatiner">
      <img class="img" priority [fill]="true" [ngSrc]="item.icono!" alt="" />
    </div>

    <p class="label">{{ 'NAV_SIDEBAR.' + item.traduccion! | translate }}</p>
  </div>
  }
</div>